/* eslint-disable jsx-a11y/click-events-have-key-events */
import { sortBy, filter, isEmpty, isFunction, unionBy } from 'lodash';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';
import React from 'react';
import { PreviewPhoto } from '@sm360/widget-commons-basic-components';
import { ContentZonesService, LocaleService, WindowProxy } from '@sm360/widget-commons-core-services';
import {
    LightBox,
    MEDIA_QUERIES,
    ModalService,
    AnalyticsService,
    TRACKING_TAGS as TAGS,
    ShiftDigitalService,
    ADOBE_TAGS,
    AdobeService,
} from '@sm360/widget-commons-general';
import MessageHandler from '@sm360/widget-commons-forms';
import { ModelYear, PurchaseMethods, Quote, Vehicle, VehicleConstants } from '@sm360/widget-commons-vehicle';
import PaymentCalculator from '@sm360/widget-payment-calculator';
import { withAnalytics } from '@sm360/widget-commons-vdp';
import TradeIn360Default from '@sm360/widget-trade-in-360';

import { CONFIRMATION } from 'build-and-quote/constants/sections.js';
import URL from 'build-and-quote/constants/url.js';

// import SummaryContainer from 'build-and-quote/components/Summary/SummaryContainer.js';
import HeaderMessage from 'build-and-quote/components/HeaderMessage/HeaderMessage.jsx';
import VehicleSpecs from 'build-and-quote/components/Summary/components/VehicleSpecs/VehicleSpecs.jsx';
import VehicleCharacteristics from 'build-and-quote/components/Summary/components/VehicleCharacteristics/VehicleCharacteristics.jsx';
import VehicleAccessories from 'build-and-quote/components/Summary/components/VehicleAccessories/VehicleAccessories.jsx';
import VehicleVideoRender from 'build-and-quote/components/Summary/components/VehicleVideo/VehicleVideoRender.jsx';
import Disclaimers from 'build-and-quote/components/Summary/components/Disclaimers/Disclaimers.jsx';

import 'build-and-quote/components/Summary/summary.scss';

const { BoxSizeModel, CabSizeModel, DrivePowerTrainModel, ModelTrimModel, OptionsPackageModel } = ModelYear;
const { VehicleModel, VehicleBannerOverlay } = Vehicle;
const { TradeInBarWrapper: TradeIn360BarWrapper, TradeInTiles: TradeIn360Tiles } = TradeIn360Default.components;

const defaultNoIcon = 'E917';
const MODAL = 'BuildAndQuote/VehicleVideo';
const modal = ModalService.get(MODAL);

class Summary extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedModel: this.props.selectedModel,
            selectedModelTrim: this.props.selectedModelTrim,
            selectedDrivePowerTrain: this.props.selectedDrivePowerTrain,
            selectedOptionsPackage: this.props.selectedOptionsPackage,
            taxesIncluded: this.props.taxesIncluded,
            taxCodes: this.props.taxCodes,
            imageServer: this.props.imageServer,
            lightBoxIsOpen: false,
            lightBoxStartIndex: 0,
            vehicleIsStock: !!this.props.quote.vehicle.vehicleId,
            wantHeader: false,
            hasSDInitialClickSent: false,
        };
        this.toggleLightBox = this.toggleLightBox.bind(this);
        this.showVideoModal = this.showVideoModal.bind(this);
        this.onPaymentCalculatorClose = this.onPaymentCalculatorClose.bind(this);
        this.saveToGarage = this.saveToGarage.bind(this);
        this.setSDInitialClickEvent = this.setSDInitialClickEvent.bind(this);
        this.getSpecificMake = this.getSpecificMake.bind(this);
        this.pageLoaded = false;
    }

    componentWillReceiveProps(newProps) {
        if (this.props !== newProps) {
            this.setState({
                selectedModel: newProps.selectedModel,
                selectedModelTrim: newProps.selectedModelTrim,
                selectedDrivePowerTrain: newProps.selectedDrivePowerTrain,
                selectedOptionsPackage: newProps.selectedOptionsPackage,
                taxesIncluded: newProps.taxesIncluded,
                taxCodes: newProps.taxCodes,
                imageServer: newProps.imageServer,
                vehicleIsStock: !!newProps.quote.vehicle.vehicleId,
            });
            if (!this.pageLoaded && newProps.currentSection === CONFIRMATION.value) {
                this.pageLoaded = true;
                if (this.props.hasAdobeTagging) {
                    AdobeService.eventTrigger(ADOBE_TAGS.BUILDER_STEPS('confirmation'), 'global-overlay');
                    AdobeService.eventTrigger(ADOBE_TAGS.BUILDER_COMPLETION(newProps?.selectedModel), 'referral-exit');
                }
                ShiftDigitalService.updateDrAccessoriesFinish(
                    newProps?.selectedModel,
                    this.props.purchaseMethods.getSelectedPurchaseMethod()
                );
            }
        }
    }

    onPaymentCalculatorClose() {
        if (this.props.quote.isQuoteInGarage()) {
            this.props.saveToGarage();
        }
    }

    /*
    * Need to send drInitialClick events only once when user interact with DR tool
    * This will send event and set state so it will not send the event again
    */
    setSDInitialClickEvent() {
        ShiftDigitalService.updateDrInitialClick(this.props.quote.id, this.props?.quote?.vehicle || '');
        this.setState({ hasSDInitialClickSent: true });
    }

    // TODO [landrover]: Remove Land Rover logic once we have flag from backend
    getSpecificMake(make, model) {
        // As per Land rover it should display make as Land rover only for Discovery models
        // All other Land rover models (Range rover, sports, defender etc..) should not have make Land rover
        const makeName = make.toLowerCase();
        if (makeName === 'land-rover' || makeName === 'land rover') {
            const modelName = model.toLowerCase();
            // eslint-disable-next-line no-useless-escape
            const discoveryModelPattern = /^discovery[\s\-]?/i;
            const hasDiscovery = discoveryModelPattern.test(modelName);
            if (hasDiscovery) {
                // If Discovery model return make and for other return emtpy string
                return make;
            }
            return '';
        }
        return make || '';
    }

    toggleLightBox() {
        AnalyticsService.gaTrigger(TAGS.ADDITIONNAL_PICTURES(WindowProxy.location().pathname));
        this.setState((prevState) => {
            return {
                lightBoxIsOpen: !prevState.lightBoxIsOpen,
                lightBoxStartIndex: 0,
            };
        });
    }

    showVideoModal() {
        modal.open();
    }

    saveToGarage(withAuthenthication) {
        this.setState({ wantHeader: true });
        if (isFunction(this.props.saveToGarage)) {
            this.props.saveToGarage(withAuthenthication);
        }
        if (!this.state.hasSDInitialClickSent) this.setSDInitialClickEvent();
    }

    render() {
        let Cityfuel = 0;
        let Highwayfuel = 0;

        const imageServerOverview =
            this.state.imageServer &&
            this.state.imageServer.imageServerDomain + this.state.imageServer.imageServerSummaryOverview;

        const selectedConfiguration =
            this.state.selectedOptionsPackage && this.state.selectedOptionsPackage.configuration;
        const availableExteriorsList = selectedConfiguration && selectedConfiguration.exteriorColours;
        const optionsPackageImageUrls =
            availableExteriorsList && availableExteriorsList.filter((colour) => colour.selected).first();
        const imageServerDomain =
            this.state.imageServer &&
            this.state.imageServer.imageServerDomain + this.state.imageServer.imageServerSummaryRelative;
        const taxCodesCount = this.state.taxCodes.length;
        const taxCodesString = this.state.taxCodes.join(' / ');
        const dealerUploadedImage = this.props.vehicle && this.props.quote.vehicle.multimedia.mainPicture.url;
        const filteredIcons = this.state.selectedOptionsPackage
            ? filter(this.state.selectedOptionsPackage.configuration.featureIcons.toArray(), (featureIcon) => {
                  return featureIcon.get('code') !== defaultNoIcon;
              })
            : [];

        const featureIcons = sortBy(filteredIcons, (rankIcon) => rankIcon.get('rank'));

        let modelExtension = this.state.selectedModelTrim ? this.state.selectedModelTrim.trimExtensionDescription : '';

        const isComingSoon = this.props.quote.vehicle.flags.reduce((resolver, { type }) => {
            return resolver || type === 'COMING_SOON';
        }, false);

        const isInTransit = this.props.quote.vehicle.stickerStatusInTransit;
        const isOnOrder = this.props.quote.vehicle.stickerStatusOnOrder;
        const isVehicleSold = this.props.quote.vehicle.sold;

        let vehicleStatusFilterContent;
        if (isComingSoon) vehicleStatusFilterContent = LocaleService.t('VEHICLE_STATUS.COMING_SOON');
        if (isInTransit) vehicleStatusFilterContent = LocaleService.t('VEHICLE_STATUS.IN_TRANSIT');
        if (isOnOrder) vehicleStatusFilterContent = LocaleService.t('VEHICLE_STATUS.ON_ORDER');
        if (isVehicleSold) vehicleStatusFilterContent = LocaleService.t('VEHICLE_STATUS.IS_SOLD');

        const isVehicleStatusFilter = (isComingSoon || isInTransit || isOnOrder || isVehicleSold) &&
            !this.props.quote.vehicle.locked && (
                <VehicleBannerOverlay icon="icon-stopwatch" content={vehicleStatusFilterContent} />
            );

        let packageDescription;
        let isLease;
        let purchaseMethod;
        if (selectedConfiguration) {
            Cityfuel = selectedConfiguration.fuelCity;
            Highwayfuel = selectedConfiguration.fuelHighway;
            packageDescription = selectedConfiguration.package.description;
            isLease = selectedConfiguration.purchaseMethods.lease.selected;
            purchaseMethod = selectedConfiguration.purchaseMethods.getPurchaseMethodLabels(LocaleService).name;
        }

        if (modelExtension) {
            modelExtension = packageDescription ? `${modelExtension} • ${packageDescription}` : modelExtension;
        } else {
            modelExtension = packageDescription;
        }

        const background = `url(${ContentZonesService.getContentZone(
            'widget.build.and.buy',
            'hit.the.road.background.img'
        ).getValue()})`;
        const tradeInDescription = ContentZonesService.getContentZone(
            'widget.build.and.buy',
            'trade.in.description'
        ).getValue();
        const tradeInTitle = ContentZonesService.getContentZone('widget.build.and.buy', 'trade.in.title').getValue();
        const sectionTitle = ContentZonesService.getContentZone(
            'widget.build.and.buy',
            'trade.in.section.title'
        ).getValue();
        const buyOnlineCta = ContentZonesService.getContentZone(
            'widget.build.and.buy',
            'widget.build.and.buy.actions.cta.buy.online.text'
        );
        const getPriceCta = ContentZonesService.getContentZone(
            'widget.build.and.buy',
            'widget.build.and.buy.actions.cta.get.price.text'
        );
        const appointmentCta = ContentZonesService.getContentZone(
            'widget.build.and.buy',
            'widget.build.and.buy.actions.cta.appointment.text'
        );
        // Display new inventory catalog image or dealer uploaded image
        const displayCatalogImage = ContentZonesService.getContentZone('widget.build.and.buy', 'show.catalog.img');

        // Promo banner for tablet and bigger screen size
        const displayPromoBanner = ContentZonesService.getContentZone('widget.build.and.buy', 'promo.banner.big.img');

        // Promo banner for mobile and small screen size
        const displayPromoBannerMobile = ContentZonesService.getContentZone(
            'widget.build.and.buy',
            'promo.banner.mobile.img'
        );

        const summaryClass = ['section-summary', 'section-background', 'has-secondary-background'];
        if (this.props.currentSection !== CONFIRMATION.value) {
            summaryClass.push('disabled');
        }

        const disclaimer = [];
        if (!this.state.taxesIncluded && taxCodesCount > 1) {
            disclaimer.push(LocaleService.t('summarySection.taxesNotIncluded', { taxCodes: taxCodesString }));
        }
        if (!this.state.taxesIncluded && taxCodesCount <= 1) {
            disclaimer.push(LocaleService.t('summarySection.taxNotIncluded', { taxCodes: taxCodesString }));
        }
        disclaimer.push(LocaleService.t('summarySection.licencesNotIncluded'));
        disclaimer.push(LocaleService.t('summarySection.creditApproval', { purchaseMethod }));
        disclaimer.push(LocaleService.t('summarySection.creditWorthiness'));
        disclaimer.push(LocaleService.t('summarySection.managerValidation'));

        if (isLease) {
            disclaimer.push(LocaleService.t('summarySection.firstPayment'));
        }

        const vehicleTitle = LocaleService.t('summarySection.TITLE', {
            year: this.state.selectedModel.year,
            make: this.getSpecificMake(this.state.selectedModel.make, this.state.selectedModel.model),
            model: this.state.selectedModel.model,
            modelTrim: this.state.selectedModelTrim
                ? this.state.selectedModelTrim.getDescription(this.state.selectedModel.model)
                : '',
        });

        const shouldRenderAccessoriesSection =
            !this.props.quote.isQuoteVehicleFromInventory() ||
            (this.props.selectedAccessories.length > 0 ||
                this.props.quote.vehicle.purchaseMethods.getSelectedOptions().length > 0);

        const currentPackage =
            !isEmpty(this.props.selectedOptionsPackage) && (this.props.selectedOptionsPackage.description || '');

        const stockNo = this.props.quote.vehicle.stockNumber;

        const vinNo = this.props.quote.vehicle.vin;

        const calculator = (
            <PaymentCalculator.PaymentCalculator
                onClose={this.onPaymentCalculatorClose}
                hasCustomButton
                hasSDInitialClickSent={this.state.hasSDInitialClickSent}
                onSetSDInitialClickEvent={this.setSDInitialClickEvent}
                hasAdobeTagging={this.props.hasAdobeTagging}
                displayCreditRate={this.props.displayCreditRate}
            />
        );

        // TODO FIX nested-ternary
        /* eslint-disable no-nested-ternary */
        const handlerMessage =
            !this.props.quote.isDirty() && this.props.quote.isQuoteInGarage()
                ? LocaleService.t('summarySection.BUILD_SAVED')
                : this.state.vehicleIsStock
                    ? LocaleService.t('summarySection.BUILD_VALIDATION_STOCK')
                    : LocaleService.t('summarySection.BUILD_VALIDATION_DEFAULT');
        /* eslint-enable no-nested-ternary */

        const quoteNotSaved = this.props.quote.isDirty() || !this.props.quote.isQuoteInGarage();
        const handlerCode = quoteNotSaved ? 'warning' : 'success';

        const carMissingImages = (
            <div className="car__missing-photo">
                <p className="car__missing-photo-label sr-text is-bold">
                    {LocaleService.t('MISSING_PHOTO.NOT_AVAILABLE')}
                </p>
                <img
                    alt={vehicleTitle}
                    className="car-image-front"
                    src={`${this.state.imageServer.imageServerDomain}/ir/w960h450c${URL.NO_PHOTO}`}
                />
            </div>
        );

        let carImages;
        if (
            displayCatalogImage &&
            displayCatalogImage.getValue() === 'false' &&
            this.props.quote.isQuoteVehicleFromInventory() &&
            dealerUploadedImage
        ) {
            carImages = <img alt={vehicleTitle} className="car-image-front" src={dealerUploadedImage} />;
        } else {
            carImages =
                imageServerDomain && optionsPackageImageUrls ? (
                    <img
                        alt={vehicleTitle}
                        className="car-image-front"
                        src={imageServerDomain + optionsPackageImageUrls.get('photo1')}
                    />
                ) : (
                    carMissingImages
                );
        }

        const optionPackage = this.props.selectedOptionsPackage
            ? filter(this.props.selectedOptionsPackage.configuration.options, 'visible')
            : [];

        const tradeInTileContent = (
            <TradeIn360BarWrapper
                isShowroomV2Enabled={this.props?.isShowroomV2Enabled}
                style={{ width: '100%' }}
                quote={this.props?.quote}
                organizationUnitId={this.props?.config?.orgUnitId}
                websiteLogo={this.props?.config?.websiteLogo}
                websiteDomain={this.props?.config?.websiteDomain}
                organizationUnitPhone={this.props?.config?.orgUnitPhone}
                websiteFacebookPageUrl={this.props?.config?.websiteFacebookPageUrl}
                websiteInstagramClientId={this.props?.config?.websiteInstagramClientId}
                websiteInstagramUserId={this.props?.config?.websiteInstagramUserId}
                websiteTwitterUrl={this.props?.config?.websiteTwitterUrl}
                websiteYoutubeUrl={this.props?.config?.websiteYoutubeUrl}
                organizationUnitName={this.props?.config?.orgUnitName}
                dealerMake={this.props?.config?.dealerMake}
                isBarWrapper
            />
        );

        const trackPriceQuoteCTA = () => {
            if (this.props.hasAdobeTagging) {
                AdobeService.eventTrigger(
                    ADOBE_TAGS.REQUIRE_INFO_CTA('new', {
                        make: this.props.quote?.vehicle?.make,
                        model: this.props.quote?.vehicle?.model,
                        bodyStyle: this.props.quote?.vehicle?.bodyStyleCode,
                    }),
                    'form-submit'
                );
            }
            AnalyticsService.ga4Trigger(
                TAGS.REQUEST_INFO_CTA(this.props.quote.vehicle.model, this.props.quote.vehicle.year)
            );
        };

        const trackBuyOnlineCta = () => {
            AnalyticsService.gaTrigger(TAGS.RESERVE_IT_NOW_CTA_NEW(this.props.quote.vehicle.model));
            if (!this.state.hasSDInitialClickSent) this.setSDInitialClickEvent();
        };

        const trackBuyOnlineCtaOnEndProcessGaTag = TAGS.RESERVE_IT_NOW_PROCESS_ENDED_NEW(
            this.props.quote.vehicle.model
        );

        const trackAppointmentCta = () => {
            AnalyticsService.gaTrigger(TAGS.PREPARE_YOUR_VISIT_CTA_NEW(this.props.selectedModel.model));
            if (!this.state.hasSDInitialClickSent) this.setSDInitialClickEvent();
        };

        const appointmentCtaOnEndProcessGaTag = TAGS.PREPARE_YOUR_VISIT_PROCESS_ENDED_NEW(
            this.props.selectedModel.model
        );

        const { vehicle } = this.props.quote;
        const demoTag = vehicle.vehicleConditionType &&
            displayCatalogImage &&
            displayCatalogImage.getValue() !== 'false' &&
            vehicle.vehicleConditionType === VehicleConstants.CONDITIONS.DEMO && (
                <div className="demo-tag">{LocaleService.t('VEHICLE_STATUS.DEMO_TAG')}</div>
            );

        // Div which will display car images
        const carImagesBlock = (
            <div className="car-images">
                {demoTag}
                {isVehicleStatusFilter}
                {carImages}
                <div className="car-multimedias">
                    {!isEmpty(this.props.quote.vehicle.multimedia.video.url) && (
                        <button onClick={this.showVideoModal} className="video-cta">
                            <icon className="icon-play-button is-util" />
                            {LocaleService.t('summarySection.SEE_VIDEO')}
                        </button>
                    )}
                    {this.props.quote.vehicle.multimedia.pictures.length > 0 && (
                        <div role="button" tabIndex={0} onClick={this.toggleLightBox}>
                            <PreviewPhoto
                                imageUrl={this.props.quote.vehicle.multimedia.getMainImage360x270()}
                                noPhotoUrl={URL.NO_PHOTO}
                                pictures={this.props.quote.vehicle.multimedia.pictures}
                                yearMakeModel={this.props.quote.vehicle.getYearMakeModel()}
                            />
                        </div>
                    )}
                </div>
            </div>
        );

        const accessories = this.props.quote.id
            ? unionBy(
                  this.props.selectedAccessories,
                  this.props.quote.vehicle.purchaseMethods.getSelectedOptions(),
                  'code'
              )
            : this.props.selectedAccessories;

        return (
            <section className={summaryClass.join(' ')} style={{ backgroundImage: background }}>
                {!this.props.quote.vehicle.locked &&
                    !this.props.quote.vehicle.sold &&
                    !isEmpty(selectedConfiguration) &&
                    (this.state.wantHeader || quoteNotSaved) && (
                        <MessageHandler.MessageHandler
                            body={<HeaderMessage message={handlerMessage} saveToGarage={this.saveToGarage} />}
                            classes={['HeaderMessage']}
                            code={handlerCode}
                            canCloseElement={false}
                        />
                    )}
                <div className="bloc-container">
                    <div className="bloc-container-wrapper">
                        <div className="section-summary__content">
                            <div className="section-summary__content-header">
                                <MediaQuery maxWidth={MEDIA_QUERIES.TABLET.MAX}>{carImagesBlock}</MediaQuery>
                                {!isEmpty(selectedConfiguration) && (
                                    <div className="section-summary__content-title">
                                        <Vehicle.VehicleSummary
                                            isReserved={this.props.quote.vehicle.locked}
                                            title={vehicleTitle}
                                            packageName={
                                                currentPackage &&
                                                LocaleService.t('summarySection.PACKAGE_NAME', {
                                                    package: currentPackage,
                                                })
                                            }
                                            vehicleStockNo={stockNo}
                                            vehicleVinNo={vinNo}
                                            purchaseMethods={selectedConfiguration.purchaseMethods}
                                            taxCodes={taxCodesString}
                                            optionalDemoTag={
                                                displayCatalogImage &&
                                                displayCatalogImage.getValue() === 'false' &&
                                                vehicle.vehicleConditionType &&
                                                vehicle.vehicleConditionType === VehicleConstants.CONDITIONS.DEMO
                                            }
                                            displayCreditRate={this.props.displayCreditRate}
                                            displayFactoryOrder={this.props.displayFactoryOrder}
                                        />
                                        <div className="section-summary__content-calculator">{calculator}</div>
                                        {!this.props.quote.vehicle.locked && (
                                            <div>
                                                <Vehicle.PriceQuoteCTA
                                                    vehicle={this.props.quote.vehicle}
                                                    buttonClass="sr-button-1 is-fluid"
                                                    alternativeLabel={getPriceCta && getPriceCta.getValue()}
                                                    onClick={trackPriceQuoteCTA}
                                                />
                                                <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                                                    <Vehicle.BuyOnlineCTA
                                                        quote={this.props.quote}
                                                        alternativeLabel={buyOnlineCta && buyOnlineCta.getValue()}
                                                        onClick={trackBuyOnlineCta}
                                                        onEndProcessGaTag={trackBuyOnlineCtaOnEndProcessGaTag}
                                                    />
                                                </MediaQuery>
                                                <Vehicle.AppointmentCTA
                                                    quote={this.props.quote}
                                                    alternativeLabel={appointmentCta && appointmentCta.getValue()}
                                                    buttonClass="sr-button-2 is-fluid"
                                                    onClick={trackAppointmentCta}
                                                    onEndProcessGaTag={appointmentCtaOnEndProcessGaTag}
                                                />
                                            </div>
                                        )}
                                    </div>
                                )}
                                <MediaQuery minWidth={MEDIA_QUERIES.LAPTOP.MIN}>{carImagesBlock}</MediaQuery>
                            </div>
                            <MediaQuery minWidth={MEDIA_QUERIES.TABLET.MIN}>
                                {displayPromoBanner &&
                                    displayPromoBanner.getValue() && (
                                        <div className="promo-banner">
                                            <img
                                                alt={displayPromoBanner.getValue()}
                                                src={displayPromoBanner.getValue()}
                                            />
                                        </div>
                                    )}
                            </MediaQuery>
                            <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                                {displayPromoBannerMobile &&
                                    displayPromoBannerMobile.getValue() && (
                                        <div className="promo-banner">
                                            <img
                                                alt={displayPromoBannerMobile.getValue()}
                                                src={displayPromoBannerMobile.getValue()}
                                            />
                                        </div>
                                    )}
                            </MediaQuery>
                            <div className="car-equipments_summary">
                                <VehicleSpecs
                                    imageServer={this.props.imageServer}
                                    selectedDrivePowerTrain={this.state.selectedDrivePowerTrain}
                                    Cityfuel={Cityfuel}
                                    Highwayfuel={Highwayfuel}
                                    selectedOptionsPackageExteriorColour={
                                        this.props.selectedOptionsPackageExteriorColour
                                    }
                                    selectedOptionsPackageInteriorColour={
                                        this.props.selectedOptionsPackageInteriorColour
                                    }
                                    selectedCabSize={this.props.selectedCabSize}
                                    selectedBoxSize={this.props.selectedBoxSize}
                                    vehicleConditionType={vehicle.vehicleConditionType}
                                    odometer={vehicle.odometer}
                                />
                                <VehicleCharacteristics
                                    modelTrimFeatures={this.state.selectedModelTrim}
                                    featureIcons={featureIcons}
                                    isDoubleColumnLayout={!shouldRenderAccessoriesSection}
                                    isDisplaying={!!this.state.selectedModelTrim}
                                    selectedModel={this.state.selectedModel}
                                    selectedPackage={currentPackage}
                                />
                                {shouldRenderAccessoriesSection && (
                                    <VehicleAccessories
                                        selectedAccessories={accessories}
                                        selectedModel={this.state.selectedModel}
                                        hasAvailableAccessories={!!optionPackage.length}
                                        isVehicleFromInventory={this.props.quote.isQuoteVehicleFromInventory()}
                                    />
                                )}
                            </div>
                            {!isEmpty(selectedConfiguration) &&
                                !this.props.quote.vehicle.sold && (
                                    <div>
                                        <MediaQuery
                                            minWidth={MEDIA_QUERIES.TABLET.MIN}
                                            className="vdp-wrapper-warranties"
                                        >
                                            <Vehicle.Overview
                                                title={vehicleTitle}
                                                packageName={
                                                    currentPackage &&
                                                    LocaleService.t('summarySection.PACKAGE_NAME', {
                                                        package: currentPackage,
                                                    })
                                                }
                                                purchaseMethods={selectedConfiguration.purchaseMethods}
                                                taxCodes={taxCodesString}
                                                optionalButton={calculator}
                                                imageUrl={
                                                    imageServerOverview && optionsPackageImageUrls
                                                        ? imageServerOverview + optionsPackageImageUrls.get('photo1')
                                                        : ''
                                                }
                                                isReserved={this.props.quote.vehicle.locked}
                                                sectionTitle={sectionTitle}
                                                quote={this.props.quote}
                                                optionalBuyCta={buyOnlineCta && buyOnlineCta.getValue()}
                                                optionalAppointmentCta={appointmentCta && appointmentCta.getValue()}
                                                hasSDInitialClickSent={this.state.hasSDInitialClickSent}
                                                onSetSDInitialClickEvent={this.setSDInitialClickEvent}
                                                displayCreditRate={this.props.displayCreditRate}
                                            />
                                            <Disclaimers vehicle={this.props.vehicle} />
                                            <TradeIn360Tiles
                                                descriptions={tradeInDescription}
                                                title={tradeInTitle}
                                                quote={this.props.quote}
                                                tradeInTileContent={tradeInTileContent}
                                                isShowroomV2Enabled={this.props.isShowroomV2Enabled}
                                            />
                                        </MediaQuery>
                                        <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                                            <TradeIn360Tiles
                                                descriptions={tradeInDescription}
                                                title={tradeInTitle}
                                                quote={this.props.quote}
                                                tradeInTileContent={tradeInTileContent}
                                                isShowroomV2Enabled={this.props.isShowroomV2Enabled}
                                            />
                                            <Disclaimers vehicle={this.props.vehicle} />
                                        </MediaQuery>
                                    </div>
                                )}
                        </div>
                    </div>
                </div>
                <VehicleVideoRender videoURL={this.props.quote.vehicle.multimedia.video.url} />
                {this.state.lightBoxIsOpen && (
                    <LightBox
                        pictures={this.props.quote.vehicle.multimedia.pictures}
                        toggleLightBox={this.toggleLightBox}
                        imageIndex={this.state.lightBoxStartIndex}
                    />
                )}
            </section>
        );
    }
}

Summary.defaultProps = {
    selectedModel: [],
    taxCodes: [],
    selectedAccessories: [],
    selectedOptionsPackageExteriorColour: [],
    selectedOptionsPackageInteriorColour: [],
    hasAdobeTagging: false,
    displayCreditRate: false,
    displayFactoryOrder: false,
    config: {},
};

Summary.propTypes = {
    currentSection: PropTypes.number.isRequired,
    imageServer: PropTypes.shape({
        imageServerDomain: PropTypes.string.isRequired,
        imageServerFullSize: PropTypes.string.isRequired,
    }).isRequired,
    quote: PropTypes.instanceOf(Quote.QuoteModel).isRequired,
    saveToGarage: PropTypes.func.isRequired,
    selectedAccessories: PropTypes.instanceOf(PurchaseMethods.selectedAccessories),
    selectedDrivePowerTrain: PropTypes.instanceOf(DrivePowerTrainModel).isRequired,
    selectedModel: PropTypes.shape({
        make: PropTypes.string.isRequired,
        model: PropTypes.string.isRequired,
        year: PropTypes.number.isRequired,
    }),
    selectedModelTrim: PropTypes.instanceOf(ModelTrimModel).isRequired,
    selectedOptionsPackage: PropTypes.instanceOf(OptionsPackageModel).isRequired,
    selectedOptionsPackageExteriorColour: PropTypes.shape({
        colourDescription: PropTypes.string.isRequired,
        colourTile: PropTypes.string.isRequired,
    }),
    selectedOptionsPackageInteriorColour: PropTypes.shape({
        colourDescription: PropTypes.string.isRequired,
        colourTile: PropTypes.string.isRequired,
    }),
    selectedCabSize: PropTypes.instanceOf(CabSizeModel).isRequired,
    selectedBoxSize: PropTypes.instanceOf(BoxSizeModel).isRequired,
    taxCodes: PropTypes.arrayOf(PropTypes.string.isRequired),
    taxesIncluded: PropTypes.bool.isRequired,
    // eslint-disable-next-line react/require-default-props
    isShowroomV2Enabled: PropTypes.bool,
    vehicle: PropTypes.instanceOf(VehicleModel).isRequired,
    hasAdobeTagging: PropTypes.bool,
    displayCreditRate: PropTypes.bool,
    displayFactoryOrder: PropTypes.bool,
    config: PropTypes.object,
};

Summary.displayName = 'Summary';

function mapStateToProps(state) {
    return {
        purchaseMethods: state.purchaseMethods,
        quote: state.quote,
    };
}

// <withAnalytics> only works for the inventory vehicle
export default connect(
    mapStateToProps,
    null
)(withAnalytics(Summary));

export { Summary };
